import { useState } from "react";
import { plur, formatMoneyCompact, formatMoney } from "@/lib/format";

// Levý sloupec skladů (§5). Výběr je toggle — druhé klepnutí na vybraný sklad
// zruší výběr (souhrnný režim). Na mobilu/tabletu vodorovně skrolovatelný pruh,
// na lg svislý sloupec.
export function WarehouseSidebar({ warehouses, selected, onSelect }) {
  const [q, setQ] = useState("");
  const list = warehouses.filter((w) => w.name.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <div className="space-y-2" data-testid="warehouse-sidebar">
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Najdi sklad"
        data-testid="warehouse-search"
        className="w-full h-10 bg-card border border-border rounded-full px-4 text-sm focus:outline-none focus:border-brand" />
      <div className="flex gap-2 overflow-x-auto lg:block lg:space-y-2 lg:overflow-visible pb-1 lg:pb-0">
        {list.map((w) => {
          const on = selected === w.id;
          const hasValue = w.total_value != null;
          return (
            <button key={w.id} onClick={() => onSelect(w.id)} data-testid={`warehouse-item-${w.id}`}
              className={`shrink-0 w-[220px] lg:w-full text-left p-4 rounded-[20px] border transition-colors ${on ? "border-brand border-[1.5px] bg-brand/5" : "border-border bg-card hover:border-brand/50"}`}>
              <div className="flex items-center gap-2 font-bold">
                <span className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${w.type === "central" ? "bg-brand" : "bg-muted-foreground/50"}`} />
                <span className="truncate">{w.name}</span>
              </div>
              <div className="text-xs text-muted-foreground mt-1 truncate">
                {plur(w.item_count || 0, "položka", "položky", "položek")}
                {hasValue && <span title={formatMoney(w.total_value)}> · {formatMoneyCompact(w.total_value)}</span>}
              </div>
              {w.project_trashed && (
                <div className="text-xs mt-1 font-semibold text-muted-foreground" data-testid={`wh-trashed-${w.id}`}
                  title="Zakázka je v koši. Po obnovení zakázky se sklad vrátí, po smazání z koše zmizí i se zásobou — převeďte ji dřív jinam.">
                  Zakázka v koši
                </div>
              )}
              {(w.low_count || 0) > 0 && (
                <div className="text-xs mt-1 text-amber-600 dark:text-amber-500 font-semibold" data-testid={`wh-low-${w.id}`}>
                  {plur(w.low_count, "položka dochází", "položky dochází", "položek dochází")}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
